import React, { memo } from 'react';

import SettingsPageWrapper from '../settings-page-wrapper';
import { AcceptInviteModalGuard } from './accept-invite-modal-guard';
import { AuctaneNetworkBanner, CarrierSharingDescription, ProviderTabs, PackingSlipSharingDescription } from './components';
import { PageDescription } from './components/page-description/page-description';
import messages from './messages';
import { ProvidersGridContext } from './providers-grid-context';

/**
 * @typedef {object} FulfillmentProvidersSettingsProps
 * @property {boolean} [shouldShowVendorTab]
 */

const pageMessages = {
  headerMessage: messages.pageTitle,
};

// please do not add state here.
// this will result in a rerender of the entire page, which is not an optimal solution
/** @type {React.NamedExoticComponent<FulfillmentProvidersSettingsProps>} */
export const FulfillmentProvidersSettings = memo(({ shouldShowVendorTab = false }) => {
  const headerContent = (
    <>
      <PageDescription shouldShowVendorTab={shouldShowVendorTab} />
      <CarrierSharingDescription />
      <PackingSlipSharingDescription />
      <AuctaneNetworkBanner />
    </>
  );

  return (
    <>
      <ProvidersGridContext>
        <SettingsPageWrapper
          descriptionContent={shouldShowVendorTab ? headerContent : null}
          isTabbed={shouldShowVendorTab}
          messages={pageMessages}
        >
          {shouldShowVendorTab ? null : headerContent}
          <ProviderTabs shouldShowVendorTab={shouldShowVendorTab} />
        </SettingsPageWrapper>
      </ProvidersGridContext>
      <AcceptInviteModalGuard />
    </>
  );
});

FulfillmentProvidersSettings.displayName = 'FulfillmentProvidersSettings';
